module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 35 35"
    }
  }, [_c('defs'), _c('g', {
    attrs: {
      "id": "РЎР»РѕР№_2",
      "data-name": "РЎР»РѕР№ 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "РЎР»РѕР№_1-2",
      "data-name": "РЎР»РѕР№ 1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M15,15.12a8,8,0,0,1,5.1,0c.38.14.66-.27,1-.55,1.86-1.71,3.73-3.41,5.57-5.15.3-.28.89-.41.6-1.29s-.68-.25-1,.08c-.85,1-1.06-.29-1.39-1-1-2.23-1-2.24.39-3.71,1-1,1.92-2,2.84-3,.54-.63.91-.68,1.27.29.24.66.53,1.27.81,1.89s.38,1.07-.06,1.4c-1,.79-.68,1.68-.18,2.72s1,2.25,1.49,3.43.82,2,1.67.74c.29-.42.57-.18.77.29.3.69.57,1.4.9,2a1.43,1.43,0,0,1-.2,1.86c-1.22,1.25-2.42,2.52-3.61,3.83-.51.55-.91.52-1.18-.38-.38-1.31-1.89-2.55-.13-4.07.23-.21.13-.63-.05-.88s-.48-.08-.69.18q-2.34,2.87-4.69,5.72a10.89,10.89,0,0,0-2.33,8.56,48.2,48.2,0,0,1,0,5c0,1.28-.42,1.93-1.22,1.94-2.11,0-4.23,0-6.34,0-.91,0-1.2-.83-1.18-2.16,0-2.7,0-5.39,0-8.09a4.31,4.31,0,0,0-.49-2.25,56.61,56.61,0,0,0-6.54-8.68c-.25-.29-.49-.7-.78-.13a.85.85,0,0,0,.24,1.14c1.55,1.57-.06,2.5-.34,3.63-.39,1.56-1,.7-1.56.11C2.64,17.43,1.59,16.29.52,15.21a1.49,1.49,0,0,1-.24-2c.62-1.13.85-3.59,2.38-1.61.28.37.48-.42.64-.78C3.88,9.51,4.43,8.18,5,6.88c.47-1,1-2-.16-2.88-.35-.26-.29-.76-.08-1.22.31-.68.62-1.35.89-2.06S6.31-.2,6.83.37C8,1.65,9.14,2.9,10.33,4.08a1.62,1.62,0,0,1,.23,2.17C10,7.4,9.66,9.62,8.25,7.74c-.15-.22-.32.06-.43.27a.73.73,0,0,0,0,.88q3.42,3.14,6.85,6.23C14.78,15.17,14.89,15.12,15,15.12Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M17.45,12.64c-2.07-.05-3.75-2.74-3.75-6s1.73-6,3.87-6,3.77,2.74,3.78,6S19.55,12.69,17.45,12.64Z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2847cc46","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIcon/iconsTemplate/contents/manExercise.vue
// module id = 386ba90f172596372f4e
// module chunks = 89